<div class="form" [formGroup]="form">
  <!-- User profile switch (Admin or not) -->

  <div class="row">
    <!-- User first name input -->
    <div class="form-group col-md-5">
      <label class="col-form-label">First Name @if (isFirstNameRequiredError()) {
        <span
        class="error">required</span>
      }</label>
      <input class="form-control"
        formControlName="firstName"
        type="text"
        name="firstName"
        required
        (input)="itzInitialisation()"/>
    </div>
    <!-- User last name input -->
    <div class="form-group col-md-5 col-md-offset-1">
      <label class="col-form-label">Last Name @if (isLastNameRequiredError()) {
        <span
        class="error">required</span>
      }</label>
      <input class="form-control"
        formControlName="lastName"
        type="text"
        name="lastName"
        required
        (input)="itzInitialisation()"/>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-5">
      <label class="col-form-label">Senority Date @if (isSenorityDateRequiredError()) {
        <span class="error">required</span>
      }</label>
      <input class="form-control"
        formControlName="userSenorityDate"
        type="date"
        name="userSenorityDate"
        required
        (change)="updateUser()"/>
    </div>

    <div class="form-group col-md-5  col-md-offset-1">
      <label class="col-form-label">RecordID (optional)</label>
      <input class="form-control"
        formControlName="userRecordID"
        type="text"
        name="userRecordID"
        (input)="updateUser()"/>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-5">
      <label class="col-form-label">Tax Residence <span class="error">*</span></label>
      <p-select
        [(ngModel)]="selectedCountryOption"
        [ngModelOptions]="{standalone: true}"
        [options]="countryOptions"
        optionLabel="label"
        [fluid]="true"
        (onChange)="onCountryChange()">
        <ng-template #item let-country>
          <span class="fi" [ngClass]="'fi-' + country.code" style="margin-right: 6px;"></span>
          {{ country.label }}
        </ng-template>
        <ng-template #selectedItem let-country>
          <span class="fi" [ngClass]="'fi-' + country.code" style="margin-right: 6px;"></span>
          {{ country.label }}
        </ng-template>
      </p-select>
    </div>
  </div>

  <!-- User login input -->
  <div class="row">
    <div class="col-md-6">
      <div class="row">
        <div class="form-group col-md-10">
          <label class="col-form-label">Login @if (isUserLoginRequiredError()) {
            <span
            class="error">required</span>
            }@if (isUserLoginFormatError()) {
            <span
            class="error">Bad Format</span>
          }</label>
          <input class="form-control"
            formControlName="userLogin"
            type="text"
            name="userLogin"
            required/>
        </div>
      </div>

      <!-- User email input -->
      <div class="row">
        <div class="form-group col-md-10">
          <label class="col-form-label">Email @if (isUserMailAddressRequiredError()) {
            <span
            class="error">required</span>
            }@if (isUserMailAddressFormatError()) {
            <span
            class="error">Bad Format</span>
          }</label>
          <input class="form-control"
            formControlName="userMailAddress"
            type="email"
            name="userMailAddress"
            />
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-10">
          <label class="col-form-label">Mission</label>
          <select class="form-control"
            formControlName="userMission"
            name="userMission"
            [compareWith]="compareClients"
            (change)="updateUser()">
            <option [ngValue]="null">— Bench —</option>
            @for (m of missions; track m.code) {
              <option [ngValue]="m">{{ m.label }}</option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="user-flags">
        <p-togglebutton
          formControlName="isAdmin"
          onLabel="Admin" offLabel="Admin"
          onIcon="pi pi-shield" offIcon="pi pi-shield"
          class="flag-admin"
          [fluid]="true"
          (onChange)="updateUser()">
        </p-togglebutton>
        <p-togglebutton
          formControlName="isBlocked"
          onLabel="Disabled" offLabel="Disabled"
          onIcon="pi pi-ban" offIcon="pi pi-ban"
          class="flag-disabled"
          [fluid]="true"
          (onChange)="updateUser()">
        </p-togglebutton>
      </div>
      @if (!!user?.id) {
        <div class="height-90">
          <p class="btnAdminManage btn" (click)="resetUserPwd()">Reset Password</p>
        </div>
      }
      <div class="action-buttons">
        <button class="btnAdminManage btn" [disabled]="form.status === 'INVALID'"
          (click)="updateOrNewUser()">Save
        </button>
      </div>
    </div>
  </div>
</div>


